// extracted by mini-css-extract-plugin
export default {"spinner":"circleLoader_spinner__D9wC5","spinnerOne":"circleLoader_spinnerOne__oyO16","spinnerTwo":"circleLoader_spinnerTwo__4sOpo"};